import { useState } from 'react';
import type { CalcTexts } from './locales';
import styles from './Calculator.module.css';

interface Props {
  onStart: () => void;
  onDecline: () => void;
  isCalculatorOpen: boolean;
  texts: CalcTexts;
}

const FADE_DURATION = 300;

export function CalculatorWelcomeCard({ onStart, onDecline, isCalculatorOpen, texts }: Props) {
  const intro = texts.start.intro;
  const [fading, setFading] = useState(false);
  const [hidden, setHidden] = useState(false);

  function handleStart() {
    setFading(true);
    setTimeout(() => { setHidden(true); onStart(); }, FADE_DURATION);
  }

  function handleDecline() {
    setFading(true);
    setTimeout(() => { setHidden(true); onDecline(); }, FADE_DURATION);
  }

  return (
    <div className={styles.calculatorWelcomeCard}>
      <p className={styles.calculatorWelcomeIntro}>{intro.eligibility_check}</p>
      <p className={styles.calculatorWelcomeDetail}>{intro.duration}</p>
      <p className={styles.calculatorWelcomeDetail}>{intro.required_information}</p>
      <p className={styles.calculatorWelcomeDetail}>{intro.data_not_saved}</p>
      {!hidden && (
        <div className={`${styles.calculatorWelcomeActions}${fading ? ` ${styles.calculatorWelcomeActionsFading}` : ''}`}>
          <button
            type="button"
            className={styles.btnPrimary}
            onClick={handleStart}
            disabled={isCalculatorOpen || fading}
          >
            {texts.start.actions.start_questions}
          </button>
          <button
            type="button"
            className={styles.btnOutline}
            disabled={isCalculatorOpen || fading}
            onClick={handleDecline}
          >
            {texts.start.actions.no_thanks}
          </button>
        </div>
      )}
    </div>
  );
}
